module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2MC44NyI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6Izk5OX08L3N0eWxlPjwvZGVmcz48dGl0bGU+c3Rhci1ncmV5PC90aXRsZT48cGF0aCBjbGFzcz0iYSIgZD0iTTMyIDBsNy41OCAyMy4ySDY0TDQ0LjI3IDM3LjYzbDcuNTEgMjMuMjRMMzIgNDYuNTQgMTIuMjIgNjAuODdsNy41MS0yMy4yNEwwIDIzLjRoMjQuNDJMMzIgMHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/images/star-grey.svg
// module id = 301
// module chunks = 1